import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';

import { Emoji } from '@/imports/ui/chakra/components/Emoji';

export const SuccessModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = (props) => {
  return (
    <Modal isCentered size="xl" {...props}>
      <ModalOverlay />

      <ModalContent>
        <ModalCloseButton />

        <ModalBody textAlign="center" pt="16" px="6">
          <Emoji
            label="pointing up"
            symbol="☝️"
            fontSize="4xl"
            lineHeight="normal"
          />

          <VStack spacing="2">
            <Heading as="h4" size="md">
              Your Export is in Progress
            </Heading>
            <Text>
              Depending on the size of your export, it might take some time to
              generate. We’ll send you an email with the download link once it’s
              complete!
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button onClick={props.onClose}>Got it!</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
